import React, {Component} from 'react';

import {locale} from "../locale/AppLocale"

import {connect} from 'react-redux'
import Loader from '../Components/Loader';
import * as productsByCategoryActions from '../actions/productsByCategoryActions'
import Breadcrumb from '../Components/Breadcrumb';


import {
    Link
} from 'react-router-dom'
import {GetEntityAttribute} from "../Helpers/Entity";

class SearchByCategory extends Component {

    constructor(props) {
        super(props);
        this.fetchCategoryProducts = this.fetchCategoryProducts.bind(this);
        this.onClickBreadCrumb = this.onClickBreadCrumb.bind(this);
    }

    componentWillMount() {
        this.props.fetchCategories(this.props.match.params.categoryId || '');
    }

    renderLinks() {
        return (
        this.props.searchCategoriesList.categories.length > 0 && <div className="category-pick">
                {
                    this.props.searchCategoriesList.categories.map((category, index) => {
                        if (category.direct_children_count === 0) {
                            return (

                                category.alias_to && category.alias_to > 0 ? (
                                        <Link key={index} to={`/${this.props.match.params.businessSlug}/search/categories/` + category.alias_to + `/products`}
                                              className="category-pick--link category-pick--has-icon btn-2" onClick={(e) => {
                                            // e.preventDefault();
                                            // this.fetchCategoryProducts(category.alias_to);
                                        }}>
                                            <i className={category.category_class} /> <span className="title">{GetEntityAttribute(category,'title')}</span>
                                        </Link>
                                    ) :(
                                        <Link key={index} to={`/${this.props.match.params.businessSlug}/search/categories/` + category.id + `/products`}
                                              className="category-pick--link category-pick--has-icon btn-2" onClick={(e) => {
                                            // e.preventDefault();
                                            // this.fetchCategoryProducts(category.id);
                                        }}>
                                            <i className={category.category_class} /> <span className="title">{GetEntityAttribute(category,'title')}</span>
                                        </Link>

                                    )

                            )
                        }

                        return (
                            <Link key={index} to={`/${this.props.match.params.businessSlug}/search/categories/` + category.id}
                                  className="category-pick--link category-pick--has-icon btn-2" onClick={(e) => {
                                e.preventDefault();
                                this.updateCategories(category.id);
                            }}>
                                <i className={category.category_class} /> <span className="title">{GetEntityAttribute(category,'title')}</span>
                            </Link>
                        )
                    })
                }
                {/*<button className="category-pick--more btn-1">{ locale.get('load_more_categories')}</button>*/}
            <div className="clearfix"></div>
        </div>
        );
    }

    renderBreadcrumb() {
        let breadcrumb = [
            {url: `/${this.props.match.params.businessSlug}/search`, title_ar: locale.get('add_new_product')},
            {url: `/${this.props.match.params.businessSlug}/search/categories`, title_ar: locale.get('categories')},
        ];

        let items = this.props.searchCategoriesList.selectedCategory.breadcrumb || [];
        items.forEach((category, index) => {
            if (index !== 0) {
                if (category.id) {
                    category.url = `/${this.props.match.params.businessSlug}/search/categories/${category.id}`;
                } else {
                    category.url = '';
                }
            }
            breadcrumb.push(category);
        });

        return (
            breadcrumb.length > 0 && <div className="panel-1--breadcrumb">
                <Breadcrumb onClickHandler={this.onClickBreadCrumb} isClickable={true} items={breadcrumb} />
            </div>
        );
    }

    onClickBreadCrumb(e, category) {
        if (category.id) {
            e.preventDefault();
            this.updateCategories(category.id);
        }
    }

    render() {
        return (
            <div>
                <Loader completed={this.props.searchCategoriesList.fetched}>
                    {this.renderBreadcrumb()}
                    <div className="clearfix"></div>
                    {this.renderLinks()}
                    <div className="clearfix"></div>
                </Loader>
            </div>
        );
    }


    updateCategories(parentId = null) {

        this.props.history.push(`/${this.props.match.params.businessSlug}/search/categories/${parentId}`);
        this.props.fetchCategories(parentId);
    }

    fetchCategoryProducts(categoryId) {
        this.props.history.push(`/${this.props.match.params.businessSlug}/search/categories/${categoryId}/products`);
        this.props.resetCategories();
    }

}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {

    return {
        auth: state.auth,
        searchCategoriesList: state.searchCategoriesList,
        categoryProducts: state.findCategoryProducts,
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        fetchCategories: (parentId) => dispatch(productsByCategoryActions.fetchCategoriesList(parentId)),
        resetCategories: () => dispatch(productsByCategoryActions.resetCategories()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchByCategory);